// ICON TRADING CO. — bilingual content & product data

export const CONTACT = {
  emailPrimary: "sales@icontradingksa.com",
  email: "icontradingco.sa@gmail.com",
  whatsapp: "966555097802", // used for wa.me links
  phones: ["+966 555 097 802", "+966 502 140 427", "+966 569 370 320"],
  addressEn: "10th Street, beside Dana Mall, 32242, Dammam, K.S.A.",
  addressAr: "الشارع العاشر، بجوار دانة مول، ٣٢٢٤٢، الدمام، المملكة العربية السعودية",
  website: "ICONTRADINGKSA.COM",
  catalogue: "/assets/ICON_Trading_Company_Profile.pdf",
  mapsQuery: "icon trading company,Beside Dana Mall, 10th st, Al Souq, Dammam 32241",
};

export const STATS = [
  { value: "600+", en: "Customers Served", ar: "عميل تمت خدمته" },
  { value: "8", en: "Core In-Stock Lines", ar: "خطوط أساسية بالمخزون" },
  { value: "7", en: "Industries Covered", ar: "قطاعات صناعية" },
  { value: "2024", en: "Established In", ar: "تأسست عام" },
];

export const t = {
  en: {
    dir: "ltr",
    nav: {
      home: "Home",
      about: "About Us",
      products: "Products",
      vision: "Vision & Industries",
      contact: "Contact",
      cta: "Request a Quote",
      langLabel: "العربية",
    },
    hero: {
      badge: "Industrial Supplies · Dammam · K.S.A.",
      titleA: "Industrial Supply",
      titleB: "Excellence",
      titleC: "from the heart of the Eastern Province",
      subtitle:
        "ICON Trading Co. is a premier industrial supply powerhouse — bridging global manufacturing excellence with regional industrial needs. High-performance rubber, advanced sealing solutions and comprehensive industrial materials, available locally and sourced globally.",
      ctaPrimary: "Explore Products",
      ctaSecondary: "تواصل معنا",
      scroll: "Scroll to discover",
    },
    marquee: "Rubber Sheets · Gaskets · Engineering Plastics · Packings & Sealings · Caster Wheels · Belts · Industrial Mesh · Bearings · Sealing Solutions ·",
    homeCaps: {
      overline: "What we supply",
      title: "A single trusted source for the materials that keep industry running",
      desc: "Eight in-stock core pillars covering the highest-velocity material lines for maintenance, fabrication and day-to-day procurement — backed by a deep additional supply range.",
      cta: "View full catalogue",
    },
    homeShowroom: {
      overline: "Strategic showroom",
      title: "On-ground presence in Dammam",
      desc: "Our strategically located showroom and warehouse combine international quality standards with local market accessibility — serving B2B clients and direct customers with on-hand stock across core categories.",
      cta: "About ICON",
    },
    homeIndustries: {
      overline: "Built for the field",
      title: "Engineered to perform in the Kingdom's most demanding conditions",
      desc: "From upstream energy to renewables — ready to serve across the heavy and light industrial spectrum.",
    },
    homeCta: {
      title: "From a single gasket to a full procurement supply list — we cover it all.",
      desc: "Let's build a partnership. Get an itemised quotation with straightforward, transparent pricing.",
      cta: "Get in touch",
    },
    about: {
      badge: "About Us",
      title: "Driving industrial excellence",
      lead: "ICON Trading Co. stands as a premier industrial supply powerhouse, bridging the critical gap between global manufacturing excellence and regional industrial needs.",
      body1:
        "Established in the heart of Saudi Arabia's industrial sector, we specialise in the import and distribution of high-performance rubber products, advanced sealing solutions, and comprehensive industrial materials. Our strategically located showroom and warehouse combine international quality standards with local market accessibility — serving both B2B clients and direct customers with exceptional reliability and efficiency.",
      body2:
        "Located at the heart of Saudi Arabia's most active industrial corridor, we are positioned to support the Kingdom's growing industrial demands with the accessibility, depth, and responsiveness that modern procurement requires.",
      showroomCaption: "Our showroom · Dammam, Eastern Province",
      pillarsTitle: "How we serve",
      pillars: [
        { t: "For Businesses", d: "Walk-in, direct purchase, no minimums." },
        { t: "For Contractors", d: "Project sourcing, consolidated supply, technical product guidance on every order." },
        { t: "For Industrial Sites", d: "Project supply, emergency response, bulk procurement, full traceability." },
      ],
      advTitle: "Why choose ICON Trading Co.?",
    },
    products: {
      badge: "Products",
      title: "A powerhouse of industrial materials",
      desc: "Whether it's local stock on core products or global sourcing beyond — explore the depth that lets procurement teams consolidate under one trusted supplier.",
      coreTitle: "Core Product Categories",
      coreDesc: "Eight in-stock pillars covering the highest-velocity material lines for industrial maintenance, fabrication and day-to-day procurement.",
      addTitle: "Raw Materials & Additional Supplies",
      addDesc: "Beyond the core products, ICON maintains a wide range of complementary supplies — engineered to keep procurement consolidated under a single trusted supplier.",
      specs: "Range / Types",
      industries: "Industries served",
      inStock: "In Stock",
      sourced: "Sourced",
    },
    vision: {
      badge: "Vision & Industries",
      visionTitle: "Our Vision",
      visionText: "To become one of the most trusted industrial supply partners in the Kingdom — connecting the right materials with the right industries, delivering reliability and accessibility where it matters most.",
      missionTitle: "Our Mission",
      missionText: "To deliver comprehensive, reliable industrial material solutions that enhance operational performance and reduce downtime — through strategic sourcing, technical depth, and exceptional service.",
      values: ["Excellence Through Service", "Precision In Supply"],
      indTitle: "Industries we specialise in",
      indDesc: "Ready to serve across the heavy and light industrial spectrum — from upstream energy to renewables — with materials engineered to perform in the Kingdom's most demanding operating conditions.",
      advTitle: "The ICON advantage",
      advDesc: "On-ground presence in Dammam, on-hand stock across core categories, and sourcing capability beyond — built to serve clients reliably on every order.",
    },
    contact: {
      badge: "Contact",
      title: "Let's build a partnership",
      desc: "From a single gasket to a full shutdown supply list — reach out for an itemised quotation with transparent pricing.",
      name: "Your name",
      company: "Company",
      message: "What do you need supplied?",
      send: "Send via WhatsApp",
      sendEmail: "Send via Email",
      download: "Download Catalogue",
      emailLabel: "Email",
      phoneLabel: "Sales / WhatsApp",
      additionalLabel: "Additional Lines",
      addressLabel: "Showroom",
      hoursLabel: "Response",
      hours: "Immediate Response Team · B2B & Direct Service",
      formTitle: "Send us your requirement",
    },
    footer: {
      tagline: "Premier Industrial Supply Solutions",
      desc: "A powerhouse of industrial materials supply in the Eastern Province — local stock on core products, global sourcing beyond.",
      explore: "Explore",
      reach: "Reach Us",
      rights: "All rights reserved.",
      download: "Download Catalogue",
    },
  },
  ar: {
    dir: "rtl",
    nav: {
      home: "الرئيسية",
      about: "من نحن",
      products: "المنتجات",
      vision: "الرؤية والقطاعات",
      contact: "تواصل معنا",
      cta: "اطلب عرض سعر",
      langLabel: "English",
    },
    hero: {
      badge: "توريدات صناعية · الدمام · المملكة العربية السعودية",
      titleA: "تميّز في التوريدات",
      titleB: "الصناعية",
      titleC: "من قلب المنطقة الشرقية",
      subtitle:
        "شركة أيكون التجارية قوة رائدة في مجال التوريدات الصناعية — تجسر الفجوة بين التميز التصنيعي العالمي واحتياجات السوق الإقليمي. منتجات مطاطية عالية الأداء، وحلول إحكام متطورة، ومواد صناعية شاملة، متوفرة محلياً ومستوردة عالمياً.",
      ctaPrimary: "استكشف المنتجات",
      ctaSecondary: "Contact Us",
      scroll: "مرّر للاكتشاف",
    },
    marquee: "ألواح مطاط · جوانات · بلاستيك هندسي · حشوات وإحكام · عجلات تحميل · سيور · شبك صناعي · رولمان بلي · حلول إحكام ·",
    homeCaps: {
      overline: "ماذا نورّد",
      title: "مصدر واحد موثوق للمواد التي تُبقي الصناعة تعمل",
      desc: "ثمانية خطوط أساسية بالمخزون تغطي أكثر المواد طلباً للصيانة والتصنيع والشراء اليومي — مدعومة بمجموعة توريدات إضافية واسعة.",
      cta: "عرض الكتالوج كاملاً",
    },
    homeShowroom: {
      overline: "معرض استراتيجي",
      title: "حضور ميداني في الدمام",
      desc: "يجمع معرضنا ومستودعنا المتميز الموقع بين معايير الجودة العالمية وسهولة الوصول المحلي — لخدمة عملاء الأعمال والعملاء المباشرين بمخزون جاهز عبر الفئات الأساسية.",
      cta: "عن أيكون",
    },
    homeIndustries: {
      overline: "مصمّمة للميدان",
      title: "مُهيّأة للأداء في أصعب ظروف تشغيل المملكة",
      desc: "من الطاقة التقليدية إلى المتجددة — جاهزون للخدمة عبر الطيف الصناعي الثقيل والخفيف.",
    },
    homeCta: {
      title: "من جانب واحد إلى قائمة توريد كاملة لإيقاف المصنع — نغطيها بالكامل.",
      desc: "لنبنِ شراكة. احصل على عرض سعر مفصّل بأسعار واضحة وشفافة.",
      cta: "تواصل معنا",
    },
    about: {
      badge: "من نحن",
      title: "نقود التميّز الصناعي",
      lead: "تعد شركة أيكون التجارية قوة رائدة في مجال التوريدات الصناعية، حيث تجسر الفجوة الحرجة بين التميز التصنيعي العالمي واحتياجات السوق الإقليمي.",
      body1:
        "تأسست في قلب القطاع الصناعي بالمملكة، ونحن متخصصون في استيراد وتوزيع منتجات المطاط عالية الأداء، وحلول الإحكام المتطورة، والمواد الصناعية الشاملة. يجمع معرضنا ومستودعنا المتميز الموقع بين معايير الجودة العالمية وسهولة الوصول المحلي، لخدمة عملاء الأعمال والعملاء المباشرين بموثوقية وكفاءة استثنائية.",
      body2:
        "ومن خلال موقعنا في قلب أكثر الممرات الصناعية نشاطاً في المملكة، نحن مهيؤون لدعم المتطلبات الصناعية المتزايدة بالمرونة والعمق والاستجابة التي تتطلبها عمليات الشراء الحديثة.",
      showroomCaption: "معرضنا · الدمام، المنطقة الشرقية",
      pillarsTitle: "كيف نخدمكم",
      pillars: [
        { t: "للأعمال التجارية", d: "شراء مباشر، بدون حد أدنى." },
        { t: "للمقاولين", d: "توريد المشاريع، توحيد الإمداد، وإرشاد فني للمنتج مع كل طلب." },
        { t: "للمواقع الصناعية", d: "توريد المشاريع، استجابة طارئة، شراء بالجملة، وتتبّع كامل." },
      ],
      advTitle: "لماذا تختار شركة أيكون التجارية؟",
    },
    products: {
      badge: "المنتجات",
      title: "قوة في توريد المواد الصناعية",
      desc: "سواء مخزون محلي للمنتجات الأساسية أو توريد عالمي لما بعدها — استكشف العمق الذي يتيح لفرق المشتريات التوحيد تحت مورّد واحد موثوق.",
      coreTitle: "فئات المنتجات الأساسية",
      coreDesc: "ثمانية أعمدة بالمخزون تغطي أكثر المواد طلباً للصيانة الصناعية والتصنيع والشراء اليومي.",
      addTitle: "المواد الخام والتوريدات الإضافية",
      addDesc: "بعد المنتجات الأساسية، تحتفظ أيكون بمجموعة واسعة من التوريدات المكمّلة — لإبقاء المشتريات موحّدة تحت مورّد واحد موثوق.",
      specs: "الأنواع / النطاق",
      industries: "القطاعات المخدومة",
      inStock: "متوفر بالمخزون",
      sourced: "يتم توريده",
    },
    vision: {
      badge: "الرؤية والقطاعات",
      visionTitle: "رؤيتنا",
      visionText: "أن نصبح أحد أكثر شركاء التوريد الصناعي موثوقية في المملكة — نربط المواد الصحيحة بالقطاعات الصحيحة، ونقدّم الموثوقية وسهولة الوصول حيث تهمّ أكثر.",
      missionTitle: "مهمتنا",
      missionText: "تقديم حلول مواد صناعية شاملة وموثوقة تعزّز الأداء التشغيلي وتقلّل التوقفات — عبر التوريد الاستراتيجي والعمق الفني والخدمة الاستثنائية.",
      values: ["التميز من خلال الخدمة", "الدقة في التوريد"],
      indTitle: "القطاعات التي نتخصص فيها",
      indDesc: "جاهزون للخدمة عبر الطيف الصناعي الثقيل والخفيف — من الطاقة التقليدية إلى المتجددة — بمواد مصممة للأداء في أصعب ظروف التشغيل بالمملكة.",
      advTitle: "ميزة أيكون",
      advDesc: "حضور ميداني في الدمام، مخزون جاهز عبر الفئات الأساسية، وقدرة توريد لما بعدها — مبنية لخدمة العملاء بموثوقية في كل طلب.",
    },
    contact: {
      badge: "تواصل معنا",
      title: "لنبنِ شراكة",
      desc: "من جانب واحد إلى قائمة توريد كاملة — تواصل معنا للحصول على عرض سعر مفصّل بأسعار شفافة.",
      name: "اسمك",
      company: "الشركة",
      message: "ما الذي تحتاج توريده؟",
      send: "إرسال عبر واتساب",
      sendEmail: "إرسال عبر البريد",
      download: "تحميل الكتالوج",
      emailLabel: "البريد الإلكتروني",
      phoneLabel: "المبيعات / واتساب",
      additionalLabel: "أرقام إضافية",
      addressLabel: "المعرض",
      hoursLabel: "الاستجابة",
      hours: "فريق استجابة فوري · خدمة الأعمال والعملاء المباشرين",
      formTitle: "أرسل لنا متطلباتك",
    },
    footer: {
      tagline: "حلول رائدة في التوريدات الصناعية",
      desc: "قوة في توريد المواد الصناعية بالمنطقة الشرقية — مخزون محلي للمنتجات الأساسية وتوريد عالمي لما بعدها.",
      explore: "استكشف",
      reach: "تواصل",
      rights: "جميع الحقوق محفوظة.",
      download: "تحميل الكتالوج",
    },
  },
};

const IMG = "/assets/products";

export const CORE_PRODUCTS = [
  {
    id: "rubber-sheets", image: `${IMG}/rubber-sheets.png`, inStock: true,
    en: { name: "Rubber Sheets", desc: "High-performance elastomer sheeting for sealing, lining, gasketing and anti-vibration applications — cut to size on request.",
      items: ["SBR", "Neoprene", "EPDM", "Silicone", "Nylon Insert", "Anti-Skid", "Electrical", "Rubber Mats"] },
    ar: { name: "ألواح المطاط", desc: "ألواح مطاطية عالية الأداء للإحكام والتبطين والجوانات ومقاومة الاهتزاز — تُقطع حسب الطلب.",
      items: ["SBR", "نيوبرين", "EPDM", "سيليكون", "نايلون إنسرت", "مانع انزلاق", "كهربائي", "حصائر مطاطية"] },
    industries: ["oil-gas", "manufacturing", "water"],
  },
  {
    id: "gaskets", image: `${IMG}/gaskets.png`, inStock: true,
    en: { name: "Gaskets", desc: "Precision sealing gaskets for flanges, pumps and high-pressure joints — engineered for leak-free, high-temperature service.",
      items: ["Spiral Wound", "Non-Asbestos Graphite", "Flange Gasket", "Metallic", "Paper"] },
    ar: { name: "الجوانات (الحشيات)", desc: "جوانات إحكام دقيقة للفلنجات والمضخات والوصلات عالية الضغط — مصممة لخدمة محكمة وعالية الحرارة.",
      items: ["لولبي ملفوف", "جرافيت خالٍ من الأسبستوس", "جوان فلنجة", "معدني", "ورقي"] },
    industries: ["oil-gas", "manufacturing", "water"],
  },
  {
    id: "engineering-plastics", image: `${IMG}/engineering-plastics.png`, inStock: true,
    en: { name: "Engineering Plastics", desc: "Machinable plastic rods, sheets and blocks delivering chemical resistance, low friction and dimensional stability.",
      items: ["PTFE", "HDPE", "Polyurethane", "Nylon", "Fiber", "Acrylic", "PVC"] },
    ar: { name: "البلاستيك الهندسي", desc: "قضبان وألواح وكتل بلاستيكية قابلة للتشغيل توفّر مقاومة كيميائية واحتكاكاً منخفضاً وثباتاً أبعادياً.",
      items: ["PTFE", "HDPE", "بولي يوريثين", "نايلون", "فايبر", "أكريليك", "PVC"] },
    industries: ["manufacturing", "construction", "mining"],
  },
  {
    id: "packings-sealings", image: `${IMG}/packings-sealings.png`, inStock: true,
    en: { name: "Packings & Sealings", desc: "Compression packing and sealing media for pumps, valves and rotating equipment under demanding duty.",
      items: ["PTFE", "Graphite", "Asbestos", "Fibre"] },
    ar: { name: "الحشوات والإحكام", desc: "حشوات ضغط ووسائط إحكام للمضخات والصمامات والمعدات الدوارة تحت ظروف تشغيل قاسية.",
      items: ["PTFE", "جرافيت", "أسبستوس", "ألياف"] },
    industries: ["oil-gas", "water", "manufacturing"],
  },
  {
    id: "caster-wheels", image: `${IMG}/caster-wheels.png`, inStock: true,
    en: { name: "Caster Wheels", desc: "Swivel and fixed casters across load classes — for trolleys, racks, scaffolding and material handling.",
      items: ["Heavy Duty", "Medium Duty", "Light Duty", "Scaffolding", "Pallet"] },
    ar: { name: "عجلات التحميل", desc: "عجلات دوّارة وثابتة بمختلف فئات التحميل — للعربات والرفوف والسقالات ومناولة المواد.",
      items: ["شديد التحمل", "متوسط التحمل", "خفيف التحمل", "سقالات", "بالت"] },
    industries: ["logistics", "construction", "manufacturing"],
  },
  {
    id: "belts", image: `${IMG}/belts.png`, inStock: true,
    en: { name: "Belts", desc: "Power transmission and conveying belts for drives, lines and timed systems — reliable under continuous load.",
      items: ["V-Belts", "Conveyor Belts", "Timing Belts"] },
    ar: { name: "السيور", desc: "سيور نقل حركة ونقل مواد للمحركات والخطوط والأنظمة المتزامنة — موثوقة تحت الأحمال المستمرة.",
      items: ["سيور V", "سيور ناقلة", "سيور توقيت"] },
    industries: ["manufacturing", "mining", "logistics"],
  },
  {
    id: "rubber-products", image: `${IMG}/rubber-products.png`, inStock: true,
    en: { name: "Rubber Products", desc: "A complete elastomer range — sealing, damping, coupling and fluid-transfer components for every line.",
      items: ["O-Rings", "Cords", "Mountings", "Couplings", "Bushes", "Hoses", "Foam Insulations"] },
    ar: { name: "منتجات المطاط", desc: "مجموعة مطاطية متكاملة — مكونات إحكام وامتصاص واقتران ونقل سوائل لكل خط إنتاج.",
      items: ["حلقات O", "حبال", "قواعد تثبيت", "وصلات", "جلب", "خراطيم", "عوازل فوم"] },
    industries: ["oil-gas", "manufacturing", "water"],
  },
  {
    id: "industrial-mesh", image: `${IMG}/industrial-mesh.png`, inStock: true,
    en: { name: "Industrial Mesh", desc: "Woven and perforated metal mesh for filtration, screening, guarding and fabrication.",
      items: ["SS Wire Mesh", "GI Mesh", "Perforated Sheet"] },
    ar: { name: "الشبك الصناعي", desc: "شبك معدني منسوج ومثقّب للترشيح والغربلة والحماية والتصنيع.",
      items: ["شبك سلكي ستانلس", "شبك مجلفن", "ألواح مثقّبة"] },
    industries: ["construction", "manufacturing", "mining"],
  },
];

export const ADDITIONAL_SUPPLIES = [
  {
    id: "raw-materials", image: `${IMG}/raw-materials.png`,
    en: { name: "Raw Material Sheets & Rods", items: ["Steel", "Aluminium", "Copper", "Bronze", "Brass", "Polystyrene"] },
    ar: { name: "ألواح وقضبان المواد الخام", items: ["فولاذ", "ألمنيوم", "نحاس", "برونز", "نحاس أصفر", "بوليستيرين"] },
  },
  {
    id: "safety-tools", image: `${IMG}/safety-tools.png`,
    en: { name: "Safety & Tools", items: ["PPE Equipment", "Hand Tools", "Power Tools", "Cutting Tools", "Drill Bits", "PVC Curtains"] },
    ar: { name: "السلامة والأدوات", items: ["معدات وقاية", "أدوات يدوية", "أدوات كهربائية", "أدوات قطع", "رؤوس حفر", "ستائر PVC"] },
  },
  {
    id: "mechanical-components", image: `${IMG}/mechanical-components.png`,
    en: { name: "Mechanical Components", items: ["Bearings", "Couplings", "Sprockets", "Chains", "Oil Seals", "Mechanical Seals", "Flanges", "Fittings", "Pneumatic Hose"] },
    ar: { name: "المكونات الميكانيكية", items: ["رولمان بلي", "وصلات", "تروس", "سلاسل", "أويل سيل", "إحكام ميكانيكي", "فلنجات", "تركيبات", "خراطيم هوائية"] },
  },
  {
    id: "industrial-equipment", image: `${IMG}/industrial-equipment.png`,
    en: { name: "Industrial Equipment", items: ["Hydraulic Lifting", "HVAC Systems", "Welding Materials", "Measuring Devices"] },
    ar: { name: "المعدات الصناعية", items: ["رفع هيدروليكي", "أنظمة تكييف", "مواد لحام", "أجهزة قياس"] },
  },
  {
    id: "consumables", image: `${IMG}/consumables.png`,
    en: { name: "Consumables", items: ["Lubricants", "Adhesives", "Tapes", "Abrasives", "Hoses"] },
    ar: { name: "المواد الاستهلاكية", items: ["مزلقات", "لواصق", "أشرطة لاصقة", "كاشطات", "خراطيم"] },
  },
  {
    id: "building-materials", image: `${IMG}/building-materials.png`,
    en: { name: "Building Materials", items: ["Construction Supplies", "Bolts", "Fasteners", "Painting Tools", "Machinery Movers", "Electrical Components", "Fabrication Works"] },
    ar: { name: "مواد البناء", items: ["مستلزمات إنشائية", "براغي", "مثبتات", "أدوات دهان", "ناقلات معدات", "مكونات كهربائية", "أعمال تصنيع"] },
  },
];

export const INDUSTRIES = [
  { id: "oil-gas", icon: "Flame", en: "Oil, Gas & Petrochemicals", ar: "النفط والغاز والبتروكيماويات" },
  { id: "construction", icon: "Building2", en: "Construction & Infrastructure", ar: "الإنشاءات والبنية التحتية" },
  { id: "mining", icon: "Mountain", en: "Mining & Minerals", ar: "التعدين والمعادن" },
  { id: "logistics", icon: "Truck", en: "Transportation & Logistics", ar: "النقل والخدمات اللوجستية" },
  { id: "manufacturing", icon: "Factory", en: "Manufacturing", ar: "التصنيع" },
  { id: "water", icon: "Droplets", en: "Water & Desalination", ar: "المياه والتحلية" },
  { id: "renewable", icon: "Wind", en: "Renewable Energy", ar: "الطاقة المتجددة" },
];

export const ADVANTAGES = [
  { icon: "Warehouse", en: { t: "Strategic Infrastructure", d: "Showroom and warehouse in Dammam with on-hand stock across core product categories for immediate availability." },
    ar: { t: "بنية تحتية استراتيجية", d: "معرض ومستودع في الدمام بمخزون جاهز عبر الفئات الأساسية للتوفّر الفوري." } },
  { icon: "Headset", en: { t: "Dedicated Technical Support", d: "Product guidance on material selection, grades and suitability — order the right product for the right application." },
    ar: { t: "دعم فني مخصّص", d: "إرشاد في اختيار المواد والدرجات والملاءمة — لطلب المنتج الصحيح للتطبيق الصحيح." } },
  { icon: "Globe2", en: { t: "Dual Sourcing System", d: "Sourcing across regional and international suppliers — reducing lead times and ensuring availability beyond local stock." },
    ar: { t: "نظام توريد مزدوج", d: "توريد من موردين محليين ودوليين — لتقليل أوقات التسليم وضمان التوفّر لما بعد المخزون المحلي." } },
  { icon: "BadgeCheck", en: { t: "Quality & Traceability", d: "Material documentation and batch certificates available for products requiring quality verification." },
    ar: { t: "الجودة والتتبّع", d: "توثيق المواد وشهادات الدفعات متاحة للمنتجات التي تتطلب تحقق الجودة." } },
  { icon: "Siren", en: { t: "Emergency Supply", d: "On-call response for breakdowns and critical line items." },
    ar: { t: "توريد طارئ", d: "استجابة عند الطلب للأعطال والبنود الحرجة." } },
  { icon: "Scissors", en: { t: "Custom & Fast Turnaround", d: "Cut-to-size materials and custom dimensions across rubber, plastics and sheet products." },
    ar: { t: "تخصيص وتسليم سريع", d: "قطع حسب المقاس وأبعاد مخصصة عبر المطاط والبلاستيك والألواح." } },
  { icon: "ReceiptText", en: { t: "Transparent Pricing", d: "Clear, itemised quotations with straightforward pricing." },
    ar: { t: "تسعير شفّاف", d: "عروض أسعار واضحة ومفصّلة بتسعير مباشر." } },
  { icon: "MapPin", en: { t: "On-Ground Presence", d: "Built to serve clients reliably on every order and grow as their trusted long-term supply partner." },
    ar: { t: "حضور ميداني", d: "مبنية لخدمة العملاء بموثوقية في كل طلب والنمو كشريك توريد موثوق طويل الأمد." } },
];
